import { filesApi } from './files';

export const filespresignurlvoice = filesApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreSignedUrlVoice: builder.query({
      query: ({ eventType, audioType, businessId, voiceName, voiceDescription }) => {
        let query = `s3/user/voice?eventType=${eventType}&audioType=${audioType}&voiceName=${voiceName}&voiceDescription=${voiceDescription}`;
        if (businessId) {
          query += `&businessId=${businessId}`;
        }
        return query;
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetPreSignedUrlVoiceQuery, useGetPreSignedUrlVoiceQuery, usePrefetch } = filespresignurlvoice;
